enum FilterEditorTypeEnum {
    TextBox = 0,
    Date = 1,
    DateRange = 2,
    Numeric = 3,
    ValuesCombo = 4,
    MultiSelect = 5,
    AutoComplete = 6,
    None = 7,
    Month = 8,
    Quarter = 9,
    Switch = 10,
    Week = 11
}

enum DefinedFieldEnum {
    Bound = 0,
    Display = 1
}

enum ContainerScopeEnum {
    Mapping = 3,
    Workbook = 0,
    Report = 1,
    Dashboard = 2,
    Widget = 4,
    ComparisonFilter = 5
}

enum ScopeActionEnum {
    Default,
    Combine,
    Overwrite
}


enum FilterConditionTypeEnum {
    Equals,
    Between,
    GreaterThan,
    LessThan,
    In,
    EqualsOrGreaterThan,
    EqualsOrLessThan,
    Different,
    NotBetween,
    NotIn,
    Contains,
    StartsWith
}

enum FilterModifiersEnum {
    Default,
    UserFilter,
    CreatedByViewer
}